import React from "react";

interface StatCardProps {
  label: string;
  value: string | number;
  sub?: string | number;
}

const StatCard = ({ label, value, sub }: StatCardProps): React.ReactElement => (
  <div className="cbm-stat-card">
    <div className="cbm-stat-label">{label}</div>
    <div className="cbm-stat-value">
      {value}
      {sub !== undefined && sub !== null && <span className="sub"> / {sub}</span>}
    </div>
  </div>
);

export default StatCard;
